import { decodeHTML } from 'entities';

const EMAIL_TEXT_FIELDS = new Set([
  'category',
  'categories',
  'email_subject',
  'from_address',
  'from_name',
  'label',
  'labels',
  'preview_text',
  'rationale',
  'reason',
  'sender_email',
  'sender_name',
  'snippet',
  'subject',
]);

const MAX_DECODE_PASSES = 3;

export function decodeEmailText(value: string | null | undefined): string {
  if (!value) return value ?? '';

  let decoded = value;
  for (let pass = 0; pass < MAX_DECODE_PASSES && decoded.includes('&'); pass += 1) {
    const next = decodeHTML(decoded);
    if (next === decoded) break;
    decoded = next;
  }

  return decoded;
}

function isPlainRecord(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== 'object') return false;
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

function decodeKnownFields(value: unknown, decodeStrings: boolean): unknown {
  if (typeof value === 'string') {
    return decodeStrings ? decodeEmailText(value) : value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => decodeKnownFields(item, decodeStrings));
  }

  if (!isPlainRecord(value)) return value;

  return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => [
      key,
      decodeKnownFields(entry, decodeStrings || EMAIL_TEXT_FIELDS.has(key)),
    ]),
  );
}

export function decodeEmailTextFields<T>(value: T): T {
  return decodeKnownFields(value, false) as T;
}
